import React from 'react'
import { Alert, Close } from '../../atoms/NewIcons'
import LoadingSvg from '../../atoms/Loading/Loading'
import useTrans from '../../../hooks/useTrans'

const Modal = ({
  variant,
  className,
  visible,
  onClose,
  alert,
  title,
  text,
  children,
  actions,
  loading,
  closeOnOverlayClick = true
}) => {
  const t = useTrans()
  
  return (
    <>
      {visible && (
        <>
          <div className={visible && 'newmodal-overlay'} onClick={closeOnOverlayClick ? onClose : undefined}></div>
          <div
            className={
              'newmodal' +
              (className ? ' ' + className : '') +
              (variant === 'checkout' ? ' newmodal--checkout' : '') +
              (actions ? ' newmodal--actions' : '')
            }
          >
            {loading ? (
              <LoadingSvg />
            ) : (
              <>
                {onClose && (
                  <button className="newmodal__close" onClick={onClose} aria-label={t("chiudi")}>
                    <Close />
                  </button>
                )}
                {alert && (
                  <span className="newmodal__alert">
                    <Alert />
                  </span>
                )}
                {title && <p className="newmodal__title">{title}</p>}
                {(text || children) && (
                  <div className="newmodal__content">
                    {text && <div className="newmodal__text">{text}</div>}
                    {children && <div className="newmodal__custom-content">{children}</div>}
                  </div>
                )}
                {actions && <div className="newmodal__actions">{actions}</div>}{' '}
              </>
            )}
          </div>
        </>
      )}
    </>
  )
}

export default React.memo(Modal)
